import createReactClass from 'create-react-class';
import _ from 'lodash';
import Moment from 'moment';
import React from 'react';
import PublishMixin from '../../../mixins/publish-mixin';

export default createReactClass({
  displayName: 'label',
  mixins: [PublishMixin],

  getDefaultProps: function () {
    return {
      type: '',
      className: '',
      prefix: '',
      postfix: '',
      dateFormat: 'DD/MM/YYYY'
    };
  },

  render: function () {
    let val = this.props.literal || this.get() || '';
    let style = _.extend({}, { display: 'inline-table' }, this.props.style);
    let className = '';

    if (val instanceof Date || this.props.type == 'date')
      val = new Moment(val).format(this.props.dateFormat);

    if (this.props.className) className = this.props.className;

    if (this.props.type == 'number' || this.props.type == 'currency') {
      className += ' bz-align-right label';
      if (val == '') val = 0;
    }

    className += ' label-control';

    if (this.props.type == 'currency') val = parseFloat(val).toFixed(2);

    return (
      <label className={className} style={style}>
        <strong>
          {this.props.prefix}
          {val.toString()}
          {this.props.postfix}
        </strong>
      </label>
    );
  }
});
